import { IonButton, IonIcon } from "@ionic/react";
import { checkmarkCircle, refreshCircle } from "ionicons/icons";
import type { SpendingConfiguration } from "../types";
import { DashboardRow } from "./DashboardRow";

interface ResultScreenProps {
  configuration: SpendingConfiguration;
  formatter: Intl.NumberFormat;
  spendByDay: Record<string, number>;
  onStartNewPeriod: () => void;
}

export function ResultScreen({ configuration, formatter, spendByDay, onStartNewPeriod }: ResultScreenProps) {
  const totalSpent = Object.values(spendByDay).reduce((total, value) => total + value, 0);
  const remainingBalance = configuration.periodAllowance - totalSpent;
  const isWithinBudget = remainingBalance >= 0;

  return (
    <main className="tracker-screen result-screen">
      <section className="result-hero">
        <IonIcon icon={isWithinBudget ? checkmarkCircle : refreshCircle} className={isWithinBudget ? "good" : "warn"} />
        <h1>{isWithinBudget ? "Nice work" : "No worries"}</h1>
        <p>{isWithinBudget ? "You stayed within your spending allowance." : "You went over this time. Reset and go again."}</p>
      </section>

      <section className="dashboard-rows">
        <DashboardRow formatter={formatter} title="Allowance" value={configuration.periodAllowance} />
        <DashboardRow formatter={formatter} title="Total Spent" value={totalSpent} />
        <DashboardRow
          formatter={formatter}
          isNegative={!isWithinBudget}
          title={isWithinBudget ? "Left Over" : "Over By"}
          value={Math.abs(remainingBalance)}
        />
      </section>

      <IonButton expand="block" size="large" onClick={onStartNewPeriod}>
        Start New Period
      </IonButton>
    </main>
  );
}
